import React from "react";
import { useEditProjectStrategicAxis } from "@planzone/view-models";
import classNames from "classnames";
import { SelectList } from "@common/selectList";
import { Props } from "./types";
import { StrategicAxisCode } from "./tag";
import { ArrowIcon } from "./arrowIcon";
import { ScoreTag } from "./scoreTag";
import styles from "./styles.scss";

function ProjectStrategicAxisEdition({
  strategicAxis,
  projectStrategicAxis,
}: Props) {
  const { editProjectStrategicAxis } =
    useEditProjectStrategicAxis(projectStrategicAxis);

  return (
    <div className={styles.projectStrategicAxisEdition}>
      <div className={styles.cell}>
        <StrategicAxisCode
          code={strategicAxis.code}
          color={strategicAxis.color}
        />
      </div>
      <p className={styles.cell}>{strategicAxis.name}</p>
      <p className={styles.weight}>{strategicAxis.weight}</p>
      <p className={styles.operator} />
      <div className={styles.cell}>
        <SelectList
          rootClassName={styles.consistencyValueSelection}
          listClassName={styles.listRoot}
        >
          {({ isOpen, select }) => ({
            input: (
              <div
                className={classNames(styles.input, {
                  [styles.openedInput]: isOpen,
                })}
              >
                <div className={styles.inputText}>
                  <div>{projectStrategicAxis.consistencyValue}</div>
                  {`${projectStrategicAxis.consistencyValue}` !==
                    strategicAxis.adequacyPossibilities[
                      `${projectStrategicAxis.consistencyValue}`
                    ] && (
                    <div>
                      {
                        strategicAxis.adequacyPossibilities[
                          `${projectStrategicAxis.consistencyValue}`
                        ]
                      }
                    </div>
                  )}
                </div>
                {isOpen ? (
                  <div>
                    <ArrowIcon className={styles.iconOpen} />
                  </div>
                ) : (
                  <ArrowIcon className={styles.iconClose} />
                )}
              </div>
            ),
            list: (
              <div className={styles.list}>
                {Object.keys(strategicAxis.adequacyPossibilities)
                  .map((index) => Number(index))
                  .sort((current, next) => (current > next ? 1 : -1))
                  .map((index) => `${index}`)
                  .map((index) => (
                    <div
                      className={styles.role}
                      key={index}
                      onClick={() => {
                        select(index);
                        editProjectStrategicAxis({
                          projectStrategicAxis,
                          nextProjectStrategicAxis: {
                            ...projectStrategicAxis,
                            consistencyValue: Number(index),
                          },
                        });
                      }}
                    >
                      <div>{index}</div>
                      {index !== strategicAxis.adequacyPossibilities[index] && (
                        <div>{strategicAxis.adequacyPossibilities[index]}</div>
                      )}
                    </div>
                  ))}
              </div>
            ),
          })}
        </SelectList>
      </div>
      <div className={styles.operator} />
      <div>
        <ScoreTag
          value={projectStrategicAxis.consistencyValue * strategicAxis.weight}
        />
      </div>
    </div>
  );
}

export { ProjectStrategicAxisEdition };
